import { c as _c } from "react/compiler-runtime";
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import useUser from 'shared/hooks/use-user';
import { UserDomainWithWebsiteInterface } from '../types/website-interface';
export default function useUserDomainsWithWebsite() {
  const $ = _c(11);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[1] !== user) {
    t1 = () => user && ["/api/dashboard/customer/user-domains/with-websites", RequestModuleEnum.UserDomainsWithWebsite];
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: userDomainsWithWebsite
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[3] !== userDomainsWithWebsite) {
    t2 = id => !!userDomainsWithWebsite?.find(el => el.website?.domainId === id)?.website;
    $[3] = userDomainsWithWebsite;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const isDomainOccupied = t2;
  let t3;
  if ($[5] !== revalidateModules) {
    t3 = async hardRevalidate => {
      await revalidateModules([RequestModuleEnum.UserDomainsWithWebsite], hardRevalidate);
    };
    $[5] = revalidateModules;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const revalidateUserDomainsWithWebsite = t3;
  let t4;
  if ($[7] !== isDomainOccupied || $[8] !== revalidateUserDomainsWithWebsite || $[9] !== userDomainsWithWebsite) {
    t4 = {
      userDomainsWithWebsite,
      isDomainOccupied,
      revalidateUserDomainsWithWebsite
    };
    $[7] = isDomainOccupied;
    $[8] = revalidateUserDomainsWithWebsite;
    $[9] = userDomainsWithWebsite;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}